import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import type { SxProps, Theme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

import { Z_INDEX } from '@/constants/z-index';

export interface GlobalLoaderProps {
  open: boolean;
  message?: string;
}

const backdropSx: SxProps<Theme> = {
  zIndex: Z_INDEX.loadingBackdrop,
  backgroundColor: 'background.default',
  flexDirection: 'column',
  gap: 2
};

export const GlobalLoader = ({ open, message }: GlobalLoaderProps) => (
  <Backdrop
    open={open}
    sx={backdropSx}
  >
    <CircularProgress />
    {message && <Typography variant='body2'>{message}</Typography>}
  </Backdrop>
);

export default GlobalLoader;
